<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M9 3.886c-3.41 0-6.32 2.12-7.5 5.114 1.18 2.993 4.09 5.114 7.5 5.114s6.32-2.12 7.5-5.114C15.32 6.007 12.41 3.886 9 3.886Zm0 8.523A3.41 3.41 0 1 1 12.41 9 3.41 3.41 0 0 1 9 12.41Zm0-5.454A2.043 2.043 0 0 0 6.955 9c0 1.132.913 2.045 2.045 2.045A2.043 2.043 0 0 0 11.046 9 2.043 2.043 0 0 0 9 6.955Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
